import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconImageInPicture$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconImageInPicture extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '6e3ae67dfdbcb28ec004f76de49f25a4491fdae6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c80f9eabb3997c6314120ae3cf4bc0a46493348a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd31281d64b67042fe515fce77510d89aa8b65d25', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 12.5h1a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15a.5.5 0 0 1-.5-.5v-1h-11zm4 5.5a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5zm5.5-7a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-3.62 5h8.24a.2.2 0 0 0 .16-.31l-2.39-3.45a.2.2 0 0 0-.33 0l-2.3 3.31-1.56-2.25a.21.21 0 0 0-.33 0l-1.65 2.39a.2.2 0 0 0 .16.31", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-image-in-picture", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-image-in-picture"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-image-in-picture":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconImageInPicture$1);
            }
            break;
    } });
}

const CosmosIconImageInPicture = CosmosIconImageInPicture$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconImageInPicture, defineCustomElement };
